import React from 'react';
import qoldoLogo from '../assets/qoldo-logo.png';

/**
 * QoldoLogo - Branded logo component with transparent background
 * Props:
 *   - className: additional CSS classes
 *   - maxWidth: max width (default: 35%)
 */
export default function QoldoLogo({ className = '', maxWidth = '35%' }) {
  return (
    <div className={`flex justify-center bg-transparent ${className}`}>
      <img 
        src={qoldoLogo} 
        alt="Qoldo" 
        className="w-auto h-auto object-contain bg-transparent"
        style={{ 
          maxWidth: maxWidth,
          height: 'auto'
        }}
      />
    </div>
  );
}
